import { Payload } from '@smile-next/uikit';
import { AuthParams } from '@/models/domain/AuthParams';

export class UpdatedCloudIdFormPayload extends Payload {
    type = 'UpdatedCloudIdFormPayload';
    constructor(public readonly authParams: AuthParams) {
        super();
    }
}
